import * as React from 'react';
import './TrialItemPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { ITrialItemReduxFormState, initialTrialItemState } from "../../../reducers/reactReduxForms/trialItem";
import { IRegistrationElement, RegistrationFormComponent, IRegistrationGrid } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent, getFormProperty, getFormPropertyLabel } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveError, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, GenericFormGroup, RadioButtonSetFormInput, SelectFormInput, DatePickerFormInput, DatePickerPartialFormInput, MaskedFormInput, NumberFormInput, CheckboxFormInput, StaticFormInput, GenericMultiFormGroup, ValidationMessage } from "../../../components/form/index";
import * as TrialItemActions from '../../../actions/trialItem';
import * as TrialActions from '../../../actions/trial';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { Form, actions, Control } from 'react-redux-form';
import { TextAreaFormInput } from '../../../components/form';
import { TrialLayout } from '../../index';
import { CollectionPage } from "../../../containers/index";
interface ITrialItemPageParams {
  trialId: number;
  trialItemId: number;
}
interface ITrialItemPageProps {
  form: Dtos.TrialItem & IRegistrationFormState;
  formState: Dtos.FormState;
  formProperties: Dtos.FormProperty[];
  reduxFormState: ITrialItemReduxFormState;
  collectionFormState: Dtos.Collection & IRegistrationFormState;
  location: Location;
  trialId: number;
  trialItemId: number;
  match: match<ITrialItemPageParams>;
  history: History;

  // From state
  trialItem: Dtos.TrialItem;
  trial: Dtos.Trial;
  trialRoles: Dtos.RoleType[];
  collection: Dtos.Collection;
  lookups: Dtos.Lookup[];
  loadingTrial: boolean;
  loadingTrialItem: boolean;
  loadTrialItemSuccess: boolean;
  loadTrialItemFailure: boolean;
  savingTrialItem: boolean;
  saveTrialItemSuccess: boolean;
  saveTrialItemFailure: boolean;
  creatingTrialItem: boolean;
  createTrialItemSuccess: boolean;
  createTrialItemFailure: boolean;
  validationFailures: Dtos.ResponseError[];
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
}
interface ITrialItemPageActions {
  clearTrialItem: TrialItemActions.ITrialItemClearActionCreator;
  loadTrialItem: TrialItemActions.ITrialItemLoadByIdActionCreator;
  saveTrialItem: TrialItemActions.ITrialItemSaveActionCreator;
  createTrialItem: TrialItemActions.ITrialItemCreateActionCreator;
  clearTrial: TrialActions.ITrialClearActionCreator;
  loadTrial: TrialActions.ITrialLoadByIdActionCreator;
  loadForm: typeof actions.load;
  changeForm: typeof actions.change;
  resetForm: typeof actions.reset;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
}
type TrialItemPageProps = ITrialItemPageProps & ITrialItemPageActions;
const formName: string = "TrialItem";
const reduxFormName: string = "reduxForms.trialItem";
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex";
const tableStyleClass: React.CSSProperties = {
  textAlign: "left",
  fontWeight: "bold",
  color: "white",
  cursor: "pointer"
};
class TrialItemPage extends React.PureComponent<TrialItemPageProps, any> {
  constructor(props: TrialItemPageProps) {
    super(props);
    this.clearTrialItem = this.clearTrialItem.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.loadForm = this.loadForm.bind(this);
  }
  componentDidMount() {
    const {
      loadTrialItem,
      navigate,
      navigateReplace,
      trialItemId,
      trialId,
      loadTrial,
      createTrialItem
    } = this.props;
    if (trialItemId) {
      loadTrialItem(trialItemId);
    } else {
      createTrialItem(trialId);
    }
    loadTrial(trialId, false, true, false, false, false);
  }
  componentWillReceiveProps(nextProps: TrialItemPageProps) {}
  componentDidUpdate(prevProps: TrialItemPageProps, prevState) {
    const {
      form,
      trialId,
      trialItemId,
      trialItem,
      navigateReplace,
      loadTrialItem,
      loadTrial,
      loadingTrialItem,
      loadTrialItemSuccess,
      createTrialItem,
      creatingTrialItem,
      createTrialItemSuccess,
      savingTrialItem,
      saveTrialItemSuccess,
      saveTrialItemFailure,
      validationFailures,
      navigate
    } = this.props;
    if (trialId && prevProps.trialId != trialId) {
      loadTrial(trialId, false, true, false, false, false);
    }
    if (trialItemId && prevProps.trialItemId != trialItemId) {
      loadTrialItem(trialItemId);
    } else if (!trialItemId && prevProps.trialItemId) {
      createTrialItem(trialId);
    }
    if (!loadingTrialItem && prevProps.loadingTrialItem) {
      if (loadTrialItemSuccess) {
        this.loadForm();
      } else {}
    }
    if (!savingTrialItem && prevProps.savingTrialItem) {
      if (saveTrialItemSuccess) {
        if (validationFailures && validationFailures.length > 0) {
          Alert.warning(<NotificationAlert alertContent={renderRegistrationFormSaveWarning(validationFailures)} icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE} />);

          // toggleMessageModal();
        } else {
          Alert.success(<NotificationAlert alertContent={renderRegistrationFormSaveSuccess()} icon={FontAwesomeIcons.Solid.CHECK} />);
        }
        if (form.saveAndReturn) {
          navigate("/trials/" + trialId + "/trialitems");
        } else if (!form.saveAndReturn && trialItemId && trialItemId > 0) {
          this.loadForm();
        } else if (!form.saveAndReturn && !trialItemId && trialItem && trialItem.id > 0) {
          navigate("/trials/" + trialId + "/trialitems/" + trialItem.id);
        }
      } else {
        Alert.error(<NotificationAlert alertContent={this.renderErrorAlert()} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
      }
    }
    if (!creatingTrialItem && prevProps.creatingTrialItem) {
      if (createTrialItemSuccess) {
        this.loadForm();
      } else {}
    }
  }
  componentWillUpdate(nextProps: TrialItemPageProps) {}
  componentWillUnmount() {
    const {
      resetForm,
      loadForm
    } = this.props;
    this.clearTrialItem();
    loadForm(reduxFormName, initialTrialItemState);
    resetForm(reduxFormName);
  }
  clearTrialItem() {
    this.props.clearTrialItem();
    this.props.clearTrial();
  }
  showTrialItem(): boolean {
    const {
      loadingTrial,
      loadingTrialItem,
      loadTrialItemSuccess
    } = this.props;
    if (!loadingTrial && !loadingTrialItem && loadTrialItemSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTrial,
      loadingTrialItem,
      loadTrialItemSuccess,
      permissions
    } = this.props;
    return <TrialLayout loading={loadingTrial || loadingTrialItem} permission={Dtos.Permission.TrialItemView} data-sentry-element="TrialLayout" data-sentry-component="TrialItemPage" data-sentry-source-file="TrialItemPage.tsx">{this.renderContent()}</TrialLayout>;
  }
  renderContent() {
    const {
      form,
      lookups,
      validationFailures,
      formProperties,
      formState,
      changeForm,
      savingTrialItem,
      permissions
    } = this.props;
    const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TrialItemUpdate, Dtos.Permission.TrialItemCreate);
    const hasRestrictedPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TrialInstitutionItemTemplateRestrictedUpdate, Dtos.Permission.TrialItemCreate);
    const formDisabled: boolean = !hasPermission && !hasRestrictedPermission || savingTrialItem || formState && formState.formStatus == Dtos.FormStatus.Disabled;
    const hasGroups: boolean = form && form.trialItemGroups && form.trialItemGroups.filter(f => f.active).length > 0;
    const hasInstitutions: boolean = form && form.trialItemInstitutions && form.trialItemInstitutions.filter(f => f.active).length > 0;
    let formComponents: {
      [index: string]: RegistrationFormComponent;
    } = {
      name: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled
      },
      categoryId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("TrialItem", "CategoryId", lookups))
        },
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
          changeForm(reduxFormName + ".category", null);
        }
      },
      description: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextAreaFormInput,
        inputDisabled: formDisabled
      },
      trialItemGroups: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled || hasInstitutions,
        inputProps: {
          multi: true,
          value: form.trialItemGroups ? form.trialItemGroups.filter(f => f.active).map(val => val.groupId) : [],
          options: generateOptionsFromLookup(findLookup("TrialItem", "TrialGroup", lookups))
        },
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value.map(v => {
            return {
              active: 1,
              groupId: v
            };
          }));
        }
      },
      trialItemInstitutions: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled || hasGroups,
        inputProps: {
          multi: true,
          value: form.trialItemInstitutions ? form.trialItemInstitutions.filter(f => f.active).map(val => val.institutionId) : [],
          options: generateOptionsFromLookup(findLookup("TrialItem", "InstitutionId", lookups))
        },
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value.map(v => {
            return {
              active: 1,
              institutionId: v
            };
          }));
        }
      },
      rank: {
        type: RegistrationComponent.RegistrationControl,
        inputType: NumberFormInput,
        inputDisabled: formDisabled
      },
      trialItemsHeader: {
        type: RegistrationComponent.RegistrationElement,
        component: <div className="border-0 d-flex pt-4 ">
                    <h3>Item Template Components</h3>
                </div>
      },
      collectionGroup: {
        type: RegistrationComponent.RegistrationElement,
        component: this.renderCollection(!hasPermission || hasRestrictedPermission)
      },
      active: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Active"
        },
        inputLabel: " "
      },
      allowIntraVersions: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Allow Intra Version"
        },
        inputLabel: " "
      },
      initialVersion: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled
      },
      sortOrderId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("TrialItem", "SortOrderId", lookups), form.sortOrderId)
        }
      }
    };
    return <div>
            <h1>Institution Item Template</h1>
            <Form model={reduxFormName} onSubmit={(val, event) => this.handleOnSubmit(val)} onSubmitFailed={val => this.handleOnSubmitFailed(val)}>
                {renderFormControls(form, "trialItem", formComponents, lookups, validationFailures, formProperties, changeForm)}

                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", false);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit
                    </button>

                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2"> Cancel </button>
                </div>
            </Form>
        </div>;
  }
  renderCollection(readonly: boolean) {
    const {
      form,
      loadingTrialItem
    } = this.props;
    let collectionId = 0;
    if (form && form.collectionId != undefined) {
      collectionId = form.collectionId;
    }
    if (form && !loadingTrialItem) {
      if (form && form.id > 0) {
        return <CollectionPage collectionId={collectionId} readonly={readonly} />;
      } else {
        return <div className="alert alert-info d-flex">
                    <div className="mr-2">
                        <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                    </div>
                    <span>Items can be added once the Item Template is saved for the first time.</span>
                </div>;
      }
    }
  }
  renderErrorAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was <strong> not </strong> saved.
        </div>;
  }
  renderWarningAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>;
  }
  renderSaveSuccessAlert(): any {
    return <div>The form has been saved successfully</div>;
  }
  handleOnSubmit(data: Dtos.TrialItem) {
    const {
      saveTrialItem,
      collection
    } = this.props;
    if (data) {
      let changes: Dtos.TrialItem = ({} as Dtos.TrialItem);
      let collectionChanges: Dtos.Collection = ({} as Dtos.Collection);
      saveTrialItem(Object.assign({
        ...data
      }, changes), Object.assign({
        ...collection
      }, collectionChanges));
    }
  }
  handleOnSubmitFailed(data: Dtos.TrialItem) {
    Alert.error(<NotificationAlert minWidth={500} alertContent={renderRegistrationFormSaveBlock()} icon={FontAwesomeIcons.Solid.BAN} />);
  }
  onCancel() {
    const {
      trialId,
      navigate
    } = this.props;
    navigate("/trials/" + trialId + "/trialitems");
  }
  loadForm() {
    const {
      loadForm,
      trialItem
    } = this.props;
    let extraData: Dtos.TrialItem = ({} as Dtos.TrialItem);
    loadForm(reduxFormName, Object.assign({
      ...trialItem
    }, extraData));
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TrialItemPageProps): ITrialItemPageProps => {
  let trialItem: Dtos.TrialItem | undefined = !(state.trialItem.formData instanceof Array) ? state.trialItem.formData : undefined;
  let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array) ? state.trials.formData : undefined;
  let collection: Dtos.Collection | undefined = !(state.reduxForms.collection instanceof Array) ? state.reduxForms.collection : undefined;
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    match: ownProps.match,
    trialId: ownProps.match ? ownProps.match.params.trialId : undefined!,
    trialItemId: ownProps.match && ownProps.match.params.trialItemId.toString() != "create" ? ownProps.match.params.trialItemId : undefined!,
    history: ownProps.history,
    location: state.routing.location,
    trialItem: trialItem!,
    collection: collection!,
    trial: trial!,
    trialRoles: state.trials.formRoles,
    loadingTrialItem: state.trialItem.loadState && state.trialItem.loadState.status == RequestState.Pending,
    loadTrialItemSuccess: state.trialItem.loadState && state.trialItem.loadState.status == RequestState.Success,
    loadTrialItemFailure: state.trialItem.loadState && state.trialItem.loadState.status == RequestState.Failure,
    loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,
    savingTrialItem: state.trialItem.saveState && state.trialItem.saveState.status == RequestState.Pending,
    saveTrialItemSuccess: state.trialItem.saveState && state.trialItem.saveState.status == RequestState.Success,
    saveTrialItemFailure: state.trialItem.saveState && state.trialItem.saveState.status == RequestState.Failure,
    creatingTrialItem: state.trialItem.createState && state.trialItem.createState.status == RequestState.Pending,
    createTrialItemSuccess: state.trialItem.createState && state.trialItem.createState.status == RequestState.Success,
    createTrialItemFailure: state.trialItem.createState && state.trialItem.createState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    lookups: state.trialItem.lookups,
    form: state.reduxForms.trialItem,
    formState: state.trialItem.formState,
    formProperties: state.trialItem.formProperties,
    collectionFormState: state.reduxForms.collection,
    reduxFormState: state.reduxForms.formState.trialItem,
    validationFailures: trialItem ? state.trialItem.validationFailures : undefined
  };
};
const mapDispatchToProps = (dispatch): ITrialItemPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadForm: bindActionCreators(actions.load, dispatch),
    changeForm: bindActionCreators(actions.change, dispatch),
    resetForm: bindActionCreators(actions.reset, dispatch),
    loadTrialItem: bindActionCreators(TrialItemActions.LoadTrialItemById, dispatch),
    clearTrialItem: bindActionCreators(TrialItemActions.Clear, dispatch),
    saveTrialItem: bindActionCreators(TrialItemActions.SaveTrialItem, dispatch),
    createTrialItem: bindActionCreators(TrialItemActions.CreateTrialItem, dispatch),
    loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
    clearTrial: bindActionCreators(TrialActions.Clear, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrialItemPage);